<!--退出对象名单查询 -->
<template>
  <div style="width: 100%">
    <div class="searchcontent">
        <el-form :inline="true"  class="demo-form-inline">
            <el-form-item>
                <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入申请人姓名" ></el-input>
            </el-form-item>
             <el-form-item>
                <el-input size="small" v-model.trim="certificateNo" placeholder="请输入申请人证件号"  maxlength="18"   onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')"></el-input>
            </el-form-item>
            <el-form-item>
                 <!-- 乡级以上 -->
                 <el-cascader
                    v-if="villageshow"
                    size="small"
                    v-model="searchForm.value"
                    :options="options"
                    :props="{ checkStrictly: true }"
                    :show-all-levels="false"
                    @active-item-change="handleItemChange"
                    clearable
                    placeholder="请选择区划地区"
                    @change="handleCateChange"
                    >
                </el-cascader>
                <!-- 村级 -->
                 <el-input size="small" v-model.trim="searchForm.value1" :placeholder="villagename" v-else :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="searchForm.policy_measure_id" placeholder="请选择政策措施"  >
                    <el-option
                    v-for="item in searchForm.policylist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                    <el-select size="small"    v-model="searchForm.year" placeholder="请选择年份" @change="yearChange(searchForm.year)">
                        <el-option
                        v-for="item in searchForm.arrYear"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
            </el-form-item> 
            <el-form-item>
                <el-button size="small" plain type="primary" icon="el-icon-search"  @click="onsearchForm">查询</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="searchtable" >
        <el-table
            ref="table"
            :data="applyaudituserlist"
            border
            stripe
            v-loading="showDataLoading"
            :header-row-style="{height:'30px'}"
            :header-cell-style="{padding:'5px'}"
            :row-style="{height:'30px'}"
            :cell-style="{padding:'5px'}"
            :height="tableHeight"
            >
            <el-table-column prop="" label="编号" width="60">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column
                prop="realName"
                label="申请人姓名"
                min-width="100"
                >
            </el-table-column>
            
            <el-table-column
                prop=""
                label="性别"
                width="80" 
                >
                <template slot-scope="scope">
                <span v-if="scope.row.sexID == 1">男</span>
                <span v-if="scope.row.sexID == 2">女</span> 
            </template>   
            </el-table-column>
            <el-table-column
                prop="certificateNo"
                label="身份证号"
                width="180"
                >
            </el-table-column>
               <el-table-column
                prop="policyMeasureName"
                label="政策名称"
                min-width="160"
                >
            </el-table-column>
            <el-table-column
                prop="enjoyCensusAddress"
                label="户籍地"
                min-width="160"
                >
            </el-table-column>
            <el-table-column
                prop="personLogoutTime"
                label="退出时间"
                width="140"
                >
            </el-table-column>
                <el-table-column
                prop="noticeInfo"
                label="退出原因"
                width="100">
                <template slot-scope="scope">
                    <span @click="getDetail(scope.row)">
                    <el-link type="primary">详情</el-link>
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <div class="pageblock">
            <el-pagination
            @size-change="handledatailSizeChange"
            @current-change="handledatailCurrentChange"
            :current-page="page"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="datailtotalCount"
            >
            </el-pagination>
        </div>
    </div>
        <!-- 退出原因 -->
    <el-dialog title="退出原因" 
    :visible.sync="diaparticularsVisible" 
    :show-close="true"  custom-class="dialog_wrap"    
    :style="'margin-top:0px;left:'+initLeft()">
        <div>
            {{particulars}}
        </div>
    </el-dialog>
    <!-- 查看资料 -->  
    <el-dialog title="查看资料" :show-close="true"
        :close-on-click-modal="false"
        custom-class="dialog_wrap"
        :visible.sync="dialogdataFormVisible"
        class="eldialog"
    
        :modal-append-to-body="true"
        append-to-body
        :style="'margin-top:0px;left:' + initLeft()">
        <Particulars :valueID="applyRecordID" :indexID="keyindex" :markID="mark" ></Particulars>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogdataFormVisible = false">取 消</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { parentregioninfoModule } from "@/request/systemmange.js";

import { regionModule } from "@/request/systemmange.js";
import { sysframe } from '@/tools/sysframe.js'
import $ from 'jquery'
import store from '@/store'
import {baseconfig,rsaBasicModuleConfig} from '@/config.js'
import {publicFun} from '@/tools/time.js'
import Particulars from "@/components/windowtoaccept/particulars.vue";
import { policydeclarationinfoModule } from "@/request/windowtoaccept.js";
import { queryrewardlogoutModel } from '@/request/aboutage.js'

export default {
  components: {
        Particulars,
    },
    props: ["valueID","indexID","markID"],
  data() {
    var validateCallTitle = (rule, value, callback) => {
      if (this.operErrors.title) {
        callback(new Error(this.operErrors.title));
      } else {
        callback();
      }
      if (this.operErrors.orderWeight) {
        callback(new Error(this.operErrors.orderWeight));
      } else {
        callback();
      }
    };
    return {
      options:[],
      values:'',
      texts:'',
      props:{
          value: 'baseRegionID',
          label: 'baseRegionName',
          children: 'cities'
      },
      mark:1,
      keyindex:0,
      tableHeight:400,
      size: '',
     
      //搜索
      page: 1,
      pagesize: 10,
      datailtotalCount: 0,
      applyaudituserlist:[],
      searchForm: {
        value1:'',
        value:'',
        keywords:'',
        identitynum:'',
        //policy:'',
        policylist:[],
        policy_measure_id:'',
        accountnaturelist:[
           { value: 0, label: "全部" },
           { value: 1, label: "农业" },
           { value: 2, label: "非农业" },
        ],
        accountnature:'',
        yearname:'',
        year:'',
        arrYear:[],
        
      },
      region_level:0,
      villageID:0,
       diaparticularsVisible:false, 
      dialogdataFormVisible:false,
      show:false,
      //进来加载数据是否展示loading圈
      showDataLoading: false,
      detailshowstatus:false,  
    // 申请记录id
      applyRecordID:0,
      particulars:'',  
      parentregioninfolist:{},
      villageshow:true,
      villagename:'',
      certificateNo:''
     };
  },
  created: async function () {
        if(store.getters.adminRegionLevel==5){
            this.villageshow=false
        }else{
             this.villageshow=true
        }
        await this.getparentregioninfo()
        var myDate = new Date();       
        this.searchForm.yearname = myDate.getFullYear(); 
        // await  this.getapplyaudit1userlist(1,10,0,'',0,this.searchForm.yearname,0,0,0,0,0) 
        this.funyear()
        this.tableHeight=$(".tab-content").height()-30-$(".searchcontent").outerHeight(true)-$(".pageblock").outerHeight(true)
        this.getpolicymeasureinfoalllist()
  },
  mounted: function () {},
  methods: {
    initLeft(){
        return sysframe.getSideBarLeft()
    },
    // 查看详情
    editFunds(row){
      this.keyindex++
      this.dialogdataFormVisible=true
      this.applyRecordID=row.applyRecordID
    },
     //年份
    funyear(){
        var myDate = new Date();       
        var thisYear = myDate.getFullYear();  // 获取当年年份
        var Section = thisYear - 2021;  // 声明一个变量 获得当前年份至想获取年份差 eg.2008
        this.searchForm.arrYear = []; // 声明一个空数组 把遍历出的年份添加到数组里
        for(var i = 0;i<=Section;i++){
            let obj={
                value:i,
                label:thisYear--
            }
            this.searchForm.arrYear.unshift(obj)
            // arrYear.push(thisYear--)
        } // 遍历并添加年份到数组
            let allobj={
                value:-1,
                label:'全部'
            }
        this.searchForm.arrYear.unshift(allobj)
        var thisYears = myDate.getFullYear(); 
        this.searchForm.arrYear.forEach(e=>{
                if(thisYears==e.label){
                    this.searchForm.year=e.value
                }
            }
        )
        console.log('年份',this.searchForm.arrYear)
    },
    yearChange(val){
            console.log(val)
        this.searchForm.arrYear.forEach(e=>{
            if(val==e.value){
                this.searchForm.yearname=e.label
            }
        })
        if(val==-1){
            this.searchForm.yearname=0
        }
        console.log(111111,this.searchForm.yearname)
        // this.searchForm.quarter_array_str=''
    },
     //获取城市列表
    async getRegionList(currentIds,p_region_id) {
        let currentIdsSize = currentIds.length;
        let region_level=currentIdsSize+1
        let this_is = this; 
        await regionModule
            .regioninfogetlist(region_level,p_region_id)
            .then((response) => {
            switch (response.data.code) {
                case 100:{
                    if(region_level==1){
                        this_is.options=[]
                        response.data.result.forEach(function(r,i){
                             if(r.baseRegionID==410000000000){
                                  this_is.options.push({value:r.baseRegionID,label:r.baseRegionName,children:[]}); 
                            }        
                        });
                        
                    }
                    if(region_level==2){
                        console.log('55555',this.parentregioninfolist.regionLevel)
                        let cities = new Array();
                        if(this.parentregioninfolist.regionLevel>=2){
                              cities.push({value:this.parentregioninfolist.cityID,label:this.parentregioninfolist.cityName,children:[]}); 
                        }else{
                             response.data.result.forEach(function(r,i){
                                cities.push({value:r.baseRegionID,label:r.baseRegionName,children:[]});         
                            });
                        }
                       
                        this_is.options.forEach(function(r,index){
                            if(r.value === currentIds[0]){
                                this_is.options[index].children = cities;
                            }
                        });
                    }
                    if(region_level==3){
                        let cities = new Array();
                         if(this.parentregioninfolist.regionLevel>=3){
                              cities.push({value:this.parentregioninfolist.districtID,label:this.parentregioninfolist.districtName,children:[]}); 
                        }else{
                             response.data.result.forEach(function(r,i){
                                cities.push({value:r.baseRegionID,label:r.baseRegionName,children:[]});         
                            });
                        }
                        this_is.options.forEach(function(r0,i0){
                            if(r0.value === currentIds[0]){
                                this_is.options[i0].children.forEach(function(r1,i1){
                                    if(r1.value === currentIds[1]){
                                        this_is.options[i0].children[i1].children = cities;
                                    }
                                });
                            }
                        });
                    }
                    if(region_level==4){
                        let cities = new Array();
                         if(this.parentregioninfolist.regionLevel>=4){
                              cities.push({value:this.parentregioninfolist.townshipID,label:this.parentregioninfolist.townshipName,children:[]}); 
                        }else{
                             response.data.result.forEach(function(r,i){
                                cities.push({value:r.baseRegionID,label:r.baseRegionName,children:[]});         
                            });
                        }
                        this_is.options.forEach(function(r0,i0){
                            if(r0.value === currentIds[0]){
                                this_is.options[i0].children.forEach(function(r1,i1){
                                    if(r1.value == currentIds[1]){
                                        console.log(i1,currentIds[1],r1.value)
                                        // this_is.options[i0].children[i1].children = cities;
                                        this_is.options[i0].children[i1].children.forEach(function(r2,i2){
                                            if(r2.value === currentIds[2]){
                                                this_is.options[i0].children[i1].children[i2].children = cities;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                    if(region_level==5){
                        let cities = new Array();
                        response.data.result.forEach(function(r,i){
                                cities.push({value:r.baseRegionID,label:r.baseRegionName});          
                        });
                        this_is.options.forEach(function(r0,i0){
                            if(r0.value === currentIds[0]){
                                this_is.options[i0].children.forEach(function(r1,i1){
                                    if(r1.value == currentIds[1]){
                                        console.log(i1,currentIds[1],r1.value)
                                        // this_is.options[i0].children[i1].children = cities;
                                        this_is.options[i0].children[i1].children.forEach(function(r2,i2){
                                            if(r2.value === currentIds[2]){
                                                 this_is.options[i0].children[i1].children[i2].children.forEach(function(r3,i3){
                                                    if(r3.value === currentIds[3]){
                                                        this_is.options[i0].children[i1].children[i2].children[i3].children  = cities;
                                                    }
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                  }
                break;
                
              }
            })
            .catch((error) => {
            console.log("error", error);
            this.loading = false;
        });
    }, 
    handleItemChange(val){
      this.values = val;
      // console.log(val)
      let valSize = val.length;
      let that = this;
      console.log(121212121212121212121212,val,valSize)
      if(valSize == 1){
        //   console.log(that.options)
        //第2级节点获取
        that.options.forEach(function(r,index){
            if(r.value === val[0]){
                that.getRegionList(val,r.value)
                return;
            }
        });
      }
      if(valSize == 2){
        // console.log(that.options)
        that.options.forEach(function(r,index){
            if(r.value === val[0]){
                r.children.forEach(function(r0,i0){
                    if(r0.value === val[1]){
                        that.getRegionList(val,r0.value)
                        return;
                    }
                });
            }
        });
      }
     if(valSize == 3){
        // console.log(that.options)
        that.options.forEach(function(r,index){
            if(r.value === val[0]){
                r.children.forEach(function(r0,i0){
                    if(r0.value === val[1]){
                         r0.children.forEach(function(r1,i1){
                            if(r1.value === val[2]){
                                that.getRegionList(val,r1.value)
                                return;
                            }
                        });
                    }
                });
            }
        });
    }
    if(valSize == 4){
        // console.log(that.options)
        that.options.forEach(function(r,index){
            if(r.value === val[0]){
                r.children.forEach(function(r0,i0){
                    if(r0.value === val[1]){
                         r0.children.forEach(function(r1,i1){
                            if(r1.value === val[2]){
                                 r1.children.forEach(function(r2,i2){
                                    if(r2.value === val[3]){
                                        that.getRegionList(val,r2.value)
                                        return;
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });
      }
    },
    handleCateChange(){
        // let this_is = this; 
        // if(this.searchForm.value.length==0){
        //     let arr=[]
        //     this_is.options=arr
        //     console.log(this_is.options)
        //     this.getRegionList([],0)
        // }
        console.log(99999,this.searchForm.value,this.searchForm.value.length)
    },
    // 获取当前区划所有父级信息详情 HYT
    async getparentregioninfo() {
        await parentregioninfoModule.parentregioninfo()
            .then((response) => {
            switch (response.data.code) {
                case 100:{
                       console.log('5555',response.data.result)
                       this.searchForm.value1=response.data.result.villageName
                       this.parentregioninfolist=response.data.result
                         console.log(Number(this.parentregioninfolist.regionLevel)-1)
                        this.getRegionList([],0)
                    }
                break;
                 case 101:{
                     this.getRegionList([],0)
                 }
                 
                break;
                default:
                    this.$message.error(response.data.message);
                break;
                
            }
            })
            .catch((error) => {
            console.log("error", error);
        });
    },
     // 3政策措施类型下拉框
    async getpolicymeasureinfoalllist() {
        await policydeclarationinfoModule.policymeasureinfoalllist()
            .then((response) => {
            switch (response.data.code) {
                case 100:{
                        let arr=[]
                            let obj={
                            value:0,
                            label:'全部'
                        }
                        response.data.result.forEach(e=>{
                            let obj={
                                value:e.policyMeasureID,
                                label:e.pmP1
                            }
                            arr.push(obj)
                        })
                        this.searchForm.policylist=arr
                            this.searchForm.policylist.unshift(obj)
                        console.log(this.searchForm.policylist)
                    }
                break;
                
            }
            })
            .catch((error) => {
            console.log("error", error);
        });
    },
    // 列表
    async getapplyaudit1userlist(page,page_size,key_words,policy_measure_id,year,enjoy_census_region_level,enjoy_census_region_id,id_number) {
        if(policy_measure_id ===''){
          policy_measure_id=0
        }
        // if(account_nature === ''){
        //   account_nature = 0
        // }
        // enjoy_census_region_id=410104001000
        // enjoy_census_region_level=5
      this.applyaudituserlist = [];
      this.showDataLoading = true;      
      await queryrewardlogoutModel.queryrewardlogoutlist(page,page_size,key_words,policy_measure_id,year,enjoy_census_region_level,enjoy_census_region_id,id_number)
        .then((response) => {
          this.showDataLoading = false;
          if(response.data.lsp !==null){
              this.lsp=response.data.lsp
          }
          switch (response.data.code) {
            case 100:
                this.applyaudituserlist = response.data.result;
                this.applyaudituserlist.forEach(e=>{
                    e.personLogoutTime = publicFun.timestampToTime(e.personLogoutTime).substring(0,10)
                    // e.userBirthday = publicFun.timestampToTime(e.userBirthday).substring(0,10)
                    //  e.marriageChanges = publicFun.timestampToTime(e.marriageChanges).substring(0,10)
                })
                 this.datailtotalCount =  response.data.recordcount;
              break;
            case 101:
            this.applyaudituserlist=[]
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch((error) => {});
    },

   //更改每页显示条数
    async handledatailSizeChange(val) {
      this.pagesize = val;
      this.page = 1;
      await this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy_measure_id,this.searchForm.yearname,this.region_level,this.villageID,this.certificateNo)
    },
    //设置当前页
    async handledatailCurrentChange(val) {
      this.page = val;
      await this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy_measure_id,this.searchForm.yearname,this.region_level,this.villageID,this.certificateNo)
    },
    // 查询
    async onsearchForm() {
        if(store.getters.adminRegionLevel==5){
            this.villageID=this.parentregioninfolist.villageID
            this.region_level=5
        }else{
            if(this.searchForm.value!=''){
                if(this.searchForm.value.length<=3){
                    this.$message.error("请选择县级以下的区划单位");
                    return
                }else{
                    this.villageID=this.searchForm.value[this.searchForm.value.length-1]
                    this.region_level=this.searchForm.value.length
                }
                console.log(this.searchForm.value)
            }else{
                this.villageID=0
                this.region_level=0
            }
        }
        this.datailtotalCount = 0;
        this.page = 1;
        await this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy_measure_id,this.searchForm.yearname,this.region_level,this.villageID,this.certificateNo)
    },
    getDetail(row){
        this.particulars=row.personLogoutReasonName
        this.diaparticularsVisible=true
    },
   
  },
};
</script>

<style scoped>
.pageblock{
    text-align: right;
    margin-top: 5px;
}
.tablecolumn{
    margin-left: 10px;
    margin-top: 5px;
}

.addorganization .el-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.pm_p1{
    min-width: 100% !important;
    /* width: 100%; */
}
.demo-form-inline>>>.el-input__inner{
    height: 32px !important;
    line-height: 32px;
}
</style>